export const RESET_CHANNELS = 'RESET_CHANNELS'
export const SET_CHANNELS = 'SET_CHANNELS'
export const RESET_CHANNELINFO = 'RESET_CHANNELINFO'
export const SET_CHANNELINFO = 'SET_CHANNELINFO'
export const SET_MESSAGES = 'SET_MESSAGES'
export const SET_MESSAGE = 'SET_MESSAGE'
export const RESET_MESSAGES = 'RESET_MESSAGES'
export const GET_UNREAD = 'GET_UNREAD'
export const SET_UNREAD = 'SET_UNREAD'
export const SET_PUBNUB = 'SET_PUBNUB'
export const RESET_PUBNUB = 'RESET_PUBNUB'
export const SET_PUBNUB_TIMESTAMP = 'SET_PUBNUB_TIMESTAMP'
export const SET_MEMBERSHIP = 'SET_MEMBERSHIP'
export const SET_CHATBAR = 'SET_CHATBAR'
export const USER_TYPING = 'USER_TYPING'



// WEBPACK FOOTER //
// ./src/store/modules/chat/types.js